import { z } from 'zod';

/**
 * Runtime env contract shared by all web apps. Each app validates its
 * import.meta.env against this at startup so a missing var fails fast rather
 * than surfacing as a confusing runtime error. Never put secrets in VITE_*
 * vars — they are embedded in the client bundle.
 */
export const envSchema = z.object({
  /**
   * Origin бэкенда, либо пустая строка.
   *
   * Пустое значение означает «тот же origin, что отдал страницу»: базовый адрес
   * становится относительным, и запрос уходит туда, откуда пришло приложение.
   * Это нужный режим, когда перед сервисами стоит прокси на самом web-хосте
   * (`apps/marketplace/nginx.conf`) — браузер работает same-origin, CORS не
   * участвует, а образ не привязан к одному имени хоста. Абсолютный URL
   * остаётся для сборок, которые обращаются к API напрямую.
   */
  VITE_API_URL: z.union([z.literal(''), z.string().url()]),
  VITE_APP_SURFACE: z.enum(['marketplace', 'back-office', 'promo-landing']),
});

export type AppEnv = z.infer<typeof envSchema>;

export function parseEnv(raw: Record<string, unknown>): AppEnv {
  return envSchema.parse(raw);
}
